import { useState, useEffect } from "react";
import { retrieveUserLogin } from "../Api.js";


/**
 * A component to display a user login data
 *
 * @returns {JSX.Element}
 */
const FormAuthenticated = () => {
  const [authenticated, setAuthenticated] = useState({
    username: "",
    email: "",
  });

  // 🔥 Save authentication state to localStorage when it changes
  useEffect(() => {
    retrieveUserLogin()
      .then((data) => {
        if (data.success) {
          //set current login info cookie
          const { username, email } = data.data;
          setAuthenticated({ username, email });
        }
      })
      .catch((error) => console.error(error));
  }, []);


  return (
    authenticated.username &&
    authenticated.email && (
      <>
        <p>{authenticated.username}</p>
        <p>{authenticated.email}</p>
      </>
    )
  );
};

export default FormAuthenticated;
